module.exports = __webpack_public_path__ + "static/media/icon-9.7c618a21.svg";